<template>
  <v-bottom-sheet
    :value="value"
    :attach="attachTarget"
    :width="sheetWidth"
    :content-class="sheetContentClass"
    hide-overlay
    data-qa="analyses_lpu_cards_sort_bottom_sheet"
    @input="close"
  >
    <v-card
      tile
      class="analyses-lpu-sort-bottom-sheet py-6 px-4 elevation-20"
    >
      <div class="text-h6 text--text mb-6">
        Сортировка
      </div>
      <v-list class="py-0">
        <v-list-item
          v-for="item in ANALYSES_LPU_SORT_ITEMS"
          :key="item.name"
          height="48"
          class="analyses-lpu-sort-bottom-sheet__item px-2"
          data-qa="analyses_lpu_cards_sort_option"
          @click="selectSort(item.value)"
        >
          <v-list-item-content class="text-body-1 text--text py-0">
            {{ item.name }}
          </v-list-item-content>
          <v-list-item-icon v-if="item.value === selectedSort">
            <v-icon
              color="primary"
              class="ma-0"
            >
              ui-icon-check
            </v-icon>
          </v-list-item-icon>
        </v-list-item>
      </v-list>
    </v-card>
  </v-bottom-sheet>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import useIsMobile from 'src/composables/useIsMobile'
import {
  ANALYSES_LPU_SORT_ITEMS,
  type AnalysesLpuSortValue,
} from 'src/components/pages/[town-translit]/diagnostika/analiz/_constants/analyses-lpu-sort'

const DRAWER_ATTACH_SELECTOR = '[data-qa="analyses_lpu_cards_filters_drawer"]'
const DRAWER_WIDTH = 376

defineProps<{
  value: boolean
  selectedSort: AnalysesLpuSortValue
}>()

type Emits = {
  (_event: 'input', _value: boolean): void
  (_event: 'select', _value: AnalysesLpuSortValue): void
}

const emit = defineEmits<Emits>()

const isMobile = useIsMobile()

const attachTarget = computed(() => (
  isMobile.value ? false : DRAWER_ATTACH_SELECTOR
))

const sheetWidth = computed(() => (
  isMobile.value ? undefined : DRAWER_WIDTH
))

const sheetContentClass = computed(() => (
  isMobile.value ? undefined : 'ml-auto rounded-0'
))

function close() {
  emit('input', false)
}

function selectSort(value: AnalysesLpuSortValue) {
  emit('select', value)
  close()
}
</script>

<style lang="scss" scoped>
.analyses-lpu-sort-bottom-sheet {
  &__item {
    min-height: 48px;
  }

  &__item :deep(.v-list-item__icon) {
    margin: 12px 0;
  }
}
</style>
